import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="notfound-container">
      <h1 className="notfound-heading">404</h1>
      <p className="notfound-text">
        Oops! Looks like you took a wrong turn into the void.
        The cosmic forces played a trick on you. Time to blast off back home!
      </p>
      <Link to="/" className="cta-button">
        Blast Off Home
      </Link>
    </div>
  );
};

export default NotFound;
